import { render, staticRenderFns } from "./ConsumableSelector.vue?vue&type=template&id=40ae0541"
import script from "./ConsumableSelector.vue?vue&type=script&lang=js"
export * from "./ConsumableSelector.vue?vue&type=script&lang=js"
import style0 from "./ConsumableSelector.vue?vue&type=style&index=0&id=40ae0541&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports